import type { OrderItem } from '@/types';

// Charged price × quantity; see "Line prices" in components/register/CONTEXT.md.
export const itemLineTotal = (item: OrderItem) =>
  (item.price ?? 0) * (item.quantity || 0);

// The online payment fee passed on to the customer is never refunded.
export const refundableItems = (items?: OrderItem[] | null) =>
  (items ?? []).filter(
    (item) => !item.transactionCost && (item.quantity ?? 0) > 0,
  );

export type TransactionInputItem = {
  amount: number;
  type: string;
  locationId: number;
};

export type BuildRefundParams = {
  remainingItemsSum: number;
  availableRefundAmount: number;
  selectedPaymentMethod: string;
  locationId: number;
};

export const buildRefundTransactions = (
  params: BuildRefundParams,
): TransactionInputItem[] => {
  const {
    remainingItemsSum,
    availableRefundAmount,
    selectedPaymentMethod,
    locationId,
  } = params;

  const refundedAmount = Math.max(0, availableRefundAmount - remainingItemsSum);

  if (refundedAmount === 0) return [];

  return [{ amount: -refundedAmount, type: selectedPaymentMethod, locationId }];
};
